'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodePalette = exports.brandPalette = exports.grayPalette = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _color3 = require('../color');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Gray Palette


var grayPalette = exports.grayPalette = {
  white: (0, _color2.default)(_color3.grayPalette.white).rgb().object(),
  gray1: (0, _color2.default)(_color3.grayPalette.gray1).rgb().object(),
  gray2: (0, _color2.default)(_color3.grayPalette.gray2).rgb().object(),
  gray3: (0, _color2.default)(_color3.grayPalette.gray3).rgb().object(),
  gray4: (0, _color2.default)(_color3.grayPalette.gray4).rgb().object(),
  gray5: (0, _color2.default)(_color3.grayPalette.gray5).rgb().object(),
  gray6: (0, _color2.default)(_color3.grayPalette.gray6).rgb().object(),
  gray7: (0, _color2.default)(_color3.grayPalette.gray7).rgb().object(),
  black: (0, _color2.default)(_color3.grayPalette.black).rgb().object()
};
var selectedColor = {
  r: 0,
  g: 193,
  b: 187
};
var brandPalette = exports.brandPalette = {
  quidTeal: {
    r: 0,
    g: 167,
    b: 184
  },
  selected: selectedColor,
  highlighted: _extends({}, selectedColor, {
    a: 0.6
  })
}; // Node Palette

var nodePalette = exports.nodePalette = {
  aqua: {
    r: 30,
    g: 215,
    b: 209
  },
  blue: {
    r: 46,
    g: 86,
    b: 188
  },
  brown: {
    r: 154,
    g: 96,
    b: 81
  },
  coral: {
    r: 240,
    g: 78,
    b: 83
  },
  emerald: {
    r: 0,
    g: 128,
    b: 79
  },
  green: {
    r: 3,
    g: 152,
    b: 73
  },
  lemon: {
    r: 234,
    g: 233,
    b: 98
  },
  lilac: {
    r: 149,
    g: 129,
    b: 188
  },
  lime: {
    r: 135,
    g: 196,
    b: 69
  },
  magenta: {
    r: 178,
    g: 34,
    b: 100
  },
  orange: {
    r: 249,
    g: 98,
    b: 30
  },
  peach: {
    r: 244,
    g: 164,
    b: 103
  },
  pink: {
    r: 215,
    g: 46,
    b: 142
  },
  purple: {
    r: 168,
    g: 73,
    b: 154
  },
  red: {
    r: 230,
    g: 30,
    b: 39
  },
  rose: {
    r: 191,
    g: 128,
    b: 146
  },
  sky: {
    r: 166,
    g: 222,
    b: 243
  },
  tan: {
    r: 193,
    g: 150,
    b: 107
  },
  teal: {
    r: 60,
    g: 135,
    b: 144
  },
  yellow: {
    r: 255,
    g: 206,
    b: 3
  }
};

var colors = _extends({}, grayPalette, brandPalette, nodePalette);

exports.default = colors;